import React,{useState,useEffect} from "react";
import "./style.css";
import moment from "moment";
import {baseURL,imgUrl} from "../../constants/index";
import {getFileById} from "../../services/index"
import {
  BrowserRouter as Router,
  Link,
} from "react-router-dom";
export function NewsViewItem(props) {
  
  const [imgStr,setImgStr] = useState("");
  const getImgUrl = (id)=>{
    getFileById({
      id:parseInt(id)
    }).then(res=>{
      if(res && res.data.length > 0){
        setImgStr(baseURL+imgUrl+res.data[0].name);
      }
    })
  }
  useEffect(()=>{
    getImgUrl(props.data.cover_photo);
  },[])
    return (
      <div className="news_item">
        <div className="news_time">
          <div className="news_time_div"></div>
          <div className="text news_time_text">
            <p>发布时间: {moment(props.data.journalism_time).format("YYYY-MM-DD")}</p>
          </div>
        </div>
        <div className="news_content">
          <div className="news_image">
          <Link to={`/detail?fileid=${props.data.id}`}><img className="img" src={imgStr} /></Link>
          </div>
          <div className="news_text">
            <div className="news_text_div">
              <div className="title" >
                <Link to={`/detail?fileid=${props.data.id}`}>{props.data.name}</Link>
                </div>
              <div className="abstract">
                <p>摘要：{props.data.abstracts}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}
